import React from "react";

function Feedback() {
    return (
        <div>
            <h1>Feedback</h1>
            <p>Feedback for this website is greatly appreciated, both by us and future users of this platform! We read every response - <a href="https://forms.gle/Z6xVTNsvtCvvYZsL9">Google Form</a></p>
        </div>
    )
}

export default Feedback;